import services from 'services'

export default {
  get(id) {
    return services.fetch(`/v1/personal-interview/${id}`)
  },

  createEvent(slot, id) {
    return services.fetch(`/v1/personal-interview/${id}/create-event`, {
      method: 'POST',
      body: slot,
    })
  },
}
